




































import Vue, { PropType } from 'vue'
import Card from './Card.vue'
import { User } from '@/api/Auth/auth.interface'
export default Vue.extend({
  components: {
    appCard: Card,
  },
  props: {
    item: Object as PropType<User>,
    fields: Array,
    titleField: {
      required: false,
      type: String,
      default: 'first_name',
    },
  },
  methods: {
    formatValue(field: string, value: string) {
      if (field === 'phone' && value) {
        return value.replace(/\s+/g, '')
      }
      return value
    },
  },
})
